import { Flex, Text } from '@gazin/ecommerce-ui'

type ProductAttributeVoltageProps = {
  available?: boolean
  value?: string
}

export default function ProductAttributeVoltage({
  available,
  value,
}: ProductAttributeVoltageProps) {
  return (
    <Flex
      alignItems="center"
      backgroundColor={!available ? '#F4F4F7' : 'transparent'}
      borderRadius="0.20rem"
      height="3.125rem"
      justifyContent="center"
      minWidth="4.875rem"
    >
      <Text marginBottom={0} textAlign="center" width="4rem">
        {value}
      </Text>
    </Flex>
  )
}
